import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import 'rxjs/add/operator/map';
import { HttpClientService } from '../http-client/http-client.service';
import { Service } from '../service';
import { TypeEmployee } from '../../models/type-employee/type-employee';

@Injectable()
export class TypeEmployeeService extends Service{

    public typeEmployees: TypeEmployee[];
    public typeEmployeesObject: any;

    constructor(
        private http: HttpClientService
    ) {
        super();
        this.typeEmployees = [];
        this.typeEmployeesObject = {};
    }

    public getAll(): Observable<TypeEmployee[]> {
        if (!!this.typeEmployees && this.typeEmployees.length > 0) {
            return Observable.create((observer: Subscriber<TypeEmployee[]>) => {
                observer.next(this.typeEmployees);
                observer.complete();
            });
        }
        const url = 'typeemployee/all';
        return this.http.get(url).map(response => {
            let r = response.json();
            if (r.ResultCode === 1) {
                this.typeEmployees = r.Result;
                this.typeEmployeesObject = this.typeEmployees.reduce((result, st) => {
                    result[String(st.Id)] = result[String(st.Id)] || {};
                    result[String(st.Id)] = st;
                    return result;
                }, {});
            } else {
                console.error('divisionsService > getAll > response', r);
            }
            return this.typeEmployees;
        }).catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/services/type-employee/type-employee.service.ts